<template>
  <div class="mb-4">
    <p class="text-sm">{{ title }}</p>
    <vs-button class="w-full" color="primary" type="border" @click="$emit('add')">
      Add {{ title }}
    </vs-button>

    <div v-for="(item, index) in value" :key="`${fieldName}-${index}`">
      <div class="flex gap-2 mt-2">
        <vs-input :name="fieldName" :data-vv-as="fieldName" class="w-full"
          :value="item"
          @input="update(index, $event)" />
        <vs-button size="medium" icon-pack="feather" icon="icon-trash" color="danger"
          @click.stop="$emit('delete', index)" />
      </div>
    </div>

    <div v-if="errors.has(fieldName)">
      <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to" style="height: 20px;">
        <span class="span-text-validation">
          The {{ title }} field is required
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PatientFormDynamicList',
  props: {
    title: String,
    fieldName: String,
    value: Array, // <-- key! uses Vue 2 default v-model prop name
    errors: Object,
  },
  methods: {
    update(index, newVal) {
      const copy = [...this.value];
      copy[index] = newVal;
      this.$emit('input', copy);
    },
  },
};
</script>
